import React from 'react';

const PlayIcon = ({ onClick }) => (
  <div
    className="mf-play-icon"
    style={{ background: 'transparent', cursor: 'pointer', pointerEvents: 'auto' }}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
  >
    <img src="/assets/demo/play-icon.svg" alt="Play Icon" style={{ width: '42px', height: '42px' }} />
  </div>
);

const formatItems = [
  {
    id: 'model-image',
    image: '/assets/demo/model-image.jpg',
    label: 'Model Image',
    sublabel: 'FHD, 2K, 4K',
    isVideo: false,
  },
  {
    id: 'model-video',
    image: '/assets/demo/trans/trans-4.png',
    label: 'Model Video',
    sublabel: '9:16 Format',
    isVideo: true,
    videoSrc: '/assets/demo/BridA-1-Out-1-6.mp4',
  },
  {
    id: 'bust-image',
    image: '/assets/demo/bust_image.png',
    label: 'Bust Image',
    sublabel: 'FHD, 2K, 4K',
    isVideo: false,
  },
  {
    id: 'bust-video',
    image: '/assets/demo/bust_video.mp4',
    label: 'Bust Video',
    sublabel: '9:16 Format',
    isVideo: true,
    videoSrc: '/assets/demo/bust_video.mp4',
  }
];

const MultipleFormatsSection = () => {
  const [activeVideo, setActiveVideo] = React.useState(null);

  return (
    <section className="mf-section">
      <div className="mf-inner">
        {/* Left Content */}
        <div className="mf-left">
          <span className="mf-badge">Multiple Formats, One Plan</span>
          <h2 className="mf-title">
            Images, Videos &amp; More<br />
            For Every Platform.
          </h2>
          <div className="mf-pill-row">
            <span className="mf-pill">Image</span>
            <span className="mf-pill">Video</span>
          </div>
        </div>

        {/* Right: Format Cards */}
        <div className="mf-cards-row">
          {formatItems.map((item) => (
            <div key={item.id} className="mf-format-card">
              <div className="mf-format-img-wrap" style={{ position: 'relative' }}>
                {item.isVideo ? (
                  <>
                    <video
                      src={item.videoSrc}
                      autoPlay
                      muted
                      loop
                      playsInline
                      className="mf-format-img"
                      style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    />
                    <PlayIcon onClick={() => setActiveVideo(item.videoSrc)} />
                  </>
                ) : (
                  <img src={item.image} alt={item.label} className="mf-format-img" />
                )}
              </div>
              <p className="mf-format-label">{item.label}</p>
              <p className="mf-format-sublabel">{item.sublabel}</p>
            </div>
          ))}
        </div>
      </div>

      {activeVideo && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, background: 'rgba(0,0,0,0.8)'
        }}>
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setActiveVideo(null)}
              style={{
                position: 'absolute', top: -35, right: 0, background: 'none',
                border: 'none', color: 'white', fontSize: 32, cursor: 'pointer',
                lineHeight: 1
              }}
            >&times;</button>
            <video src={activeVideo} controls autoPlay style={{ maxWidth: '90vw', maxHeight: '90vh' }} />
          </div>
        </div>
      )}
    </section>
  );
};

export default MultipleFormatsSection;
